<template>
    <div class="d-flex flex-column align-items-center justify-content-center content p-4 p-lg-5">
        <h1 class="mb-5">
            Reset your password
        </h1>
        <div
            v-if="token"
            class="reset-password-form"
        >
            <p class="mb-5">
                Please enter your new password below.
            </p>
            <form @submit.prevent="submitChange">
                <div class="field-wrap">
                    <label
                        for="password"
                    >
                        Password
                    </label>
                    <div class="field-wrap__input">
                        <input
                            id="password"
                            ref="password"
                            :key="'password1'"
                            v-model="password"
                            v-validate="{ required: true, regex: passwordRegex }"
                            :class="{ 'has-error': errors.has('password') }"
                            type="password"
                            name="password"
                            placeholder=""
                        >
                    </div>
                    <div
                        v-if="errors.has('password')"
                        class="py-3"
                    >
                        <div class="d-inline-block alert-error p-3 rounded-corners">
                            {{ errors.first('password') }}
                        </div>
                    </div>
                </div>
                <div class="field-wrap">
                    <label
                        for="password_confirmation"
                    >
                        Confirm Password
                    </label>
                    <div class="field-wrap__input">
                        <input
                            id="password_confirmation"
                            :key="'password2'"
                            v-model="password_confirmation"
                            v-validate="{ required: true, confirmed: 'password' }"
                            :class="{ 'has-error': errors.has('password_confirmation') }"
                            type="password"
                            name="password_confirmation"
                            placeholder=""
                        >
                    </div>
                    <div
                        v-if="errors.has('password_confirmation')"
                        class="py-3"
                    >
                        <div class="d-inline-block alert-error p-3 rounded-corners">
                            {{ errors.first('password_confirmation') }}
                        </div>
                    </div>
                </div>
                <button
                    class="btn btn--secondary btn-block"
                    type="submit"
                >
                    Submit
                </button>
            </form>
        </div>
        <div
            v-else-if="requested"
            class="reset-password-form"
        >
            <p>Thank you for requesting a password reset. Please check your email address for further instructions.</p>
        </div>
        <div
            v-else-if="!requested && !token"
            class="reset-password-form"
        >
            <form @submit.prevent="submitRequest">
                <p class="mb-5">
                    Please enter the email address your account is registered under to receive instructions to reset your
                    password.
                </p>
                <!-- Email -->
                <div class="field-wrap">
                    <label
                        for="email"
                    >
                        Email Address
                    </label>
                    <div class="field-wrap__input">
                        <input
                            id="email"
                            :key="'email'"
                            v-model="email"
                            v-validate="{ required: true, email: true }"
                            :class="{ 'has-error': errors.has('email') }"
                            type="email"
                            name="email"
                            placeholder=""
                        >
                    </div>
                    <div
                        v-if="errors.has('email')"
                        class="py-3"
                    >
                        <div class="d-inline-block alert-error p-3 rounded-corners">
                            {{ errors.first('email') }}
                        </div>
                    </div>
                </div>
                <!-- END Email -->
                <button
                    class="btn btn--secondary btn-block"
                    type="submit"
                >
                    Submit
                </button>
            </form>
        </div>
        <div v-else>
            <p>The password reset request is invalid.</p>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
    data() {
        return {
            token: null,
            requested: false,
            email: '',
            password: '',
            password_confirmation: ''
        };
    },
    computed: {
        ...mapGetters('user', [
            'authenticated',
            'confirmed'
        ]),
        ...mapState('user', [
            'passwordRegex'
        ])
    },
    mounted() {
        if (this.$route.query.token) {
            this.token = this.$route.query.token;
        }
    },
    methods: {
        ...mapActions('user', [
            'logout',
            'passwordResetChange',
            'passwordResetRequest'
        ]),
        submitChange() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.passwordResetChange({
                        password: this.password,
                        password_confirmation: this.password_confirmation,
                        token: this.token
                    })
                        .then(() => {
                            this.$toasted.success('Your password has been successfully reset. Please use the new password to login.');
                            if (this.authenticated) {
                                this.logout(false);
                            }
                            this.$router.push({ name: 'login' });
                        })
                        .catch((e) => {
                            try {
                                if (e.response.data.message) {
                                    this.$toasted.error(e.response.data.message);
                                }
                            }
                            catch (err) {
                                this.$toasted.error('An unknown error occured while attempting to process your password reset request.');
                            }
                        });
                }
                else {
                    this.$toasted.error('You have entered invalid data. Please check and submit again.');
                }
            });
        },
        submitRequest() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.passwordResetRequest({
                        email: this.email
                    })
                        .then(() => {
                            this.requested = true;
                            if (this.authenticated) {
                                this.logout(false);
                            }
                        });
                }
                else {
                    this.$toasted.error('You have entered invalid data. Please check and submit again.');
                }
            });
        }
    }
};
</script>

<style lang="scss">
    .page-password-reset {
        .content {
            max-width: 100%;
        }
        .reset-password-form {
            width: 35rem;
            max-width: 100%;
            padding: 0 3rem;
        }
    }
</style>
